import React from "react";
import styles from "./Technologies.module.scss";
import Image from "next/image";
import Marquee from "react-fast-marquee";

interface Tech {
  title: string;
  image: string;
}

const Technologies = () => {
  const technologiesArray: { title: string; technologies: Tech[] }[] = [
    {
      title: "Frontend",
      technologies: [
        {
          title: "React",
          image: "/technologies/react-hooks.png",
        },
        {
          title: "X-State",
          image: "/technologies/x-state.svg",
        },
        {
          title: "Redux",
          image: "/technologies/redux.svg",
        },
        {
          title: "Mobx",
          image: "/technologies/mobx.jpeg",
        },
        {
          title: "Zustand",
          image: "/technologies/zustand.png",
        },
      ],
    },

    {
      title: "notifications",
      technologies: [
        {
          title: "Firebase FCM",
          image: "/omnichannels/firebase.png",
        },
        {
          title: "OneSignal",
          image: "/technologies/one-signal.png",
        },
        {
          title: "Expo Push Notifications",
          image: "/technologies/expo-notifications.png",
        },
        {
          title: "Amazon Simple Notification Service (SNS)",
          image: "/technologies/Amazon Simple Notification.webp",
        },
        {
          title: "Catapush",
          image: "/technologies/catapush.webp",
        },
      ],
    },

    {
      title: "ui-libraries",
      technologies: [
        {
          title: "NativeBase",
          image: "/technologies/nativebase.webp",
        },
        {
          title: "React Native Element",
          image: "/technologies/react-native-element.webp",
        },
        {
          title: "React Native Paper",
          image: "/technologies/react-native-paper.webp",
        },
        {
          title: "React Native UI Kitten",
          image: "/technologies/React Native UI Kitten.webp",
        },
        {
          title: "RNUI",
          image: "/technologies/RNUI.webp",
        },
      ],
    },

    {
      title: "development-tools",
      technologies: [
        {
          title: "TypeScript",
          image: "/technologies/typescript.webp",
        },
        {
          title: "Eslint",
          image: "/technologies/eslint.webp",
        },
        {
          title: "Prettier",
          image: "/technologies/prettier.webp",
        },
        {
          title: "CocoaPods",
          image: "/technologies/cocoapods.webp",
        },
        {
          title: "xCode",
          image: "/technologies/x-code.webp",
        },
        {
          title: "Java Development Kit & Android Studio",
          image: "/technologies/Java Development Kit & Android Studio.webp",
        },
      ],
    },

    {
      title: "analytics",
      technologies: [
        {
          title: "Mixpanel",
          image: "/technologies/mixpanel.webp",
        },
        {
          title: "Google Analytics",
          image: "/technologies/google-analytics.webp",
        },
        {
          title: "CleverTap",
          image: "/technologies/clevertap.webp",
        },
        {
          title: "Sentry",
          image: "/technologies/sentry.webp",
        },
        {
          title: "BugSnag",
          image: "/technologies/bugsnag.webp",
        },
        {
          title: "Firebase Crashlytics",
          image: "/technologies/Firebase Crashlytics.webp",
        },
        {
          title: "Instabug",
          image: "/technologies/instabug.webp",
        },
      ],
    },

    {
      title: "ci-cd",
      technologies: [
        {
          title: "Bitrise",
          image: "/technologies/bitrise.webp",
        },
        {
          title: "AppCenter",
          image: "/technologies/appcenter.webp",
        },
        {
          title: "FastLane",
          image: "/technologies/fastlane.webp",
        },
        {
          title: "Expo EAS Builder",
          image: "/technologies/expo-EAS-builder.webp",
        },
        {
          title: "Codemagic",
          image: "/technologies/codemagic.webp",
        },
      ],
    },

    {
      title: "devops",
      technologies: [
        {
          title: "Travis CI",
          image: "/technologies/travisCI.webp",
        },
        {
          title: "Jenkins",
          image: "/technologies/jenkins.webp",
        },
        {
          title: "Circle CI",
          image: "/technologies/circleCI.webp",
        },
        {
          title: "Bitbucket",
          image: "/technologies/bitbucket.webp",
        },
        {
          title: "Github Actions",
          image: "/technologies/github-actions.webp",
        },
        {
          title: "Gitlab CI",
          image: "/technologies/gitlabCI.webp",
        },
        {
          title: "Azure Pipeline",
          image: "/technologies/azure-pipeline.webp",
        },
        {
          title: "AWS CodeBuild",
          image: "/technologies/aws-codebuild.webp",
        },
        {
          title: "AWS CodePipeline",
          image: "/technologies/aws-codepipeline.webp",
        },
        {
          title: "AWS CodeDeploy",
          image: "/technologies/aws-codedeploy.webp",
        },
        {
          title: "AWS",
          image: "/technologies/aws.webp",
        },
        {
          title: "Azure",
          image: "/technologies/azure.webp",
        },
        {
          title: "GCP",
          image: "/technologies/gcp.webp",
        },
        {
          title: "DigitalOcean",
          image: "/technologies/digital-ocean.webp",
        },
        {
          title: "Promethus",
          image: "/technologies/promethus.webp",
        },
        {
          title: "Zabbix",
          image: "/technologies/zabbix.webp",
        },
        {
          title: "AWS Cloudewatch",
          image: "/technologies/aws-cloudewatch.webp",
        },
        {
          title: "Azure Monitor",
          image: "/technologies/azure-monitor.webp",
        },
        {
          title: "Dockers",
          image: "/technologies/Dockers.webp",
        },
        {
          title: "Kubernetes",
          image: "/technologies/kubernetes.webp",
        },
        {
          title: "Ubuntu",
          image: "/technologies/ubuntu.webp",
        },
        {
          title: "Amazone Linux",
          image: "/technologies/amazone-linux.webp",
        },
        {
          title: "RHEL",
          image: "/technologies/RHEL.webp",
        },
        {
          title: "AlmaLinux",
          image: "/technologies/almalinux.webp",
        },
        {
          title: "RockyLinux",
          image: "/technologies/rockylinux.webp",
        },
        {
          title: "Fedora",
          image: "/technologies/fedora.webp",
        },
        {
          title: "Debian",
          image: "/technologies/debian.webp",
        },
        {
          title: "Nagios",
          image: "/technologies/nagios.webp",
        },
        {
          title: "Windows",
          image: "/technologies/windows.webp",
        },
        {
          title: "MAC",
          image: "/technologies/MAC.webp",
        },
      ],
    },
  ];

  const leadLogos: Tech[] = [
    { title: "React Native", image: "/react-native.webp" },
    { title: "Next.js", image: "/nextjs.webp" },
    { title: "Flutter", image: "/flutter.png" },
    { title: "Angular", image: "/angular.png" },
    { title: "Node.js", image: "/nodejs.png" },
    { title: "JavaScript", image: "/javaScript.png" },
    { title: "DotNet", image: "/dotnet.png" },
    { title: "DevOps", image: "/devops.webp" },
  ];

  const allLogos: Tech[] = [
    ...leadLogos,
    ...technologiesArray.flatMap((category) => category.technologies),
  ];

  return (
    <div className={styles["technologies-wrapper"]}>
      <div className={styles["technologies-container"]}>
        <div className={styles["technologies-header"]}>
          <p className={styles["technologies-heading"]}>Technologies</p>
          <p className={styles["technologies-subheading"]}>
            We work with cutting-edge technologies designed to solve your
            product requirements.
          </p>
        </div>
        <div className={styles["technologies-list"]}>
          <div className={styles["marquee-wrapper"]}>
            <Marquee speed={50} pauseOnHover gradient={false}>
              {allLogos.map((tech, i) => (
                <div className={styles["logo"]} key={`${tech.title}-${i}`}>
                  <Image
                    src={tech.image}
                    alt={tech.title}
                    width={120}
                    height={56}
                    className={styles["logo-img"]}
                    style={{ objectFit: "contain" }}
                  />
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Technologies;
